module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-70-min.13f6e08a.jpg";